import { useQuery } from '@tanstack/react-query';
import { getAccountDocumentDetails } from '../endpoints/accountDocument.ts';
import { ACCOUNT_DOCUMENT_QUERY_NAMESPACE } from './useAccountDocumentList.ts';

const useAccountDocumentDetail = (id: string | undefined) =>
  useQuery({
    queryKey: [ACCOUNT_DOCUMENT_QUERY_NAMESPACE, 'detail', id],
    queryFn: () => getAccountDocumentDetails(id!),
    enabled: Boolean(id),
  });

export { useAccountDocumentDetail };
